<template>
    <article class="column is-full-mobile is-half-tablet" :class="getLen">
        <div class="tile is-ancestor">
            <div class="tile is-parent">
                <div class="tile is-child notification">

                    <div class="box mt-20">
                        <p v-if="item.name" class="is-size-4">
                            <router-link :to="item.slug" @click.native="sendItem(item)">
                                {{item.name | capitalize}}
                            </router-link>
                        </p>
                        <div v-if="item.description" class="content" v-text="truncate(item.description, 100)"></div>
                        <div v-if="item.image" class="parent-image">
                            <figure class="image">
                                <a :href="albumUrl"><img :src="getImage"></a>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import { AlbumsPhotoUrl, LocationsPhotoUrl } from '../../../.env';
import { mapGetters } from 'vuex';
import StringsMixin from '../../../mixins/StringsMixin';

export default {
    props: ['item', 'link', 'defaultUrl', 'len'],
    mixins: [StringsMixin],
    data() {
        return {
            //
        };
    },

    computed: {
        getImage() {

            if(this.link === '/albums/') {
                return AlbumsPhotoUrl + '300/' + this.item.image;
            }
        },

        albumUrl() {
            return this.item.slug;
        },

        getLen() {
            if(this.len === 2) {
                return 'is-one-half-desktop';
            }
            if(this.len === 3) {
                return 'is-one-third-desktop';
            }
            return 'is-one-quarter-desktop';
        }

    },

    methods: {
        sendItem(show) {
            // console.log('send item - just console: ', this.item);
            // this.$store.dispatch('sendItem', this.item);
        }
    },

    created() {
        // console.log('album card created');
    },

};

</script>
<style lang="scss" scoped>
.tile{
    &.is-child {
        padding: 2px !important;
        .content {
            height: 120px;
        }
    }
    &.is-parent {
        padding: 5px !important;
    }
}

@media screen and (min-width: 1350px) {
    $width: 500px;
    .box {
        min-height: $width;
    }
    .parent-image {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .image {
            flex-grow: 1;
            max-width: $width;
        }
    }
}

@media screen and (min-width: 1920px) {
    $width: 600px;
    .box {
        height: $width;
    }
    .parent-image {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        height: calc(100% - 200px);
        .image {
            flex-grow: 1;
            max-width: $width;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/elements/card/AlbumCard.vue